var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{backstage: _vm.$route.path !== '/',image_body:_vm.$route.path == '/'},attrs:{"id":"app"}},[(_vm.$route.path!=='/')?_c(_vm.currentTopComponent,{tag:"component"}):_vm._e(),_c('div',{attrs:{"id":"total_content"}},[_c('router-view')],1),(_vm.$route.path!=='/')?_c(_vm.currentFooterComponent,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }